import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMenuItem, IPopupMenuConfig } from "libraries/component/popup-menu/popup-menu.component";
import { Yii } from "libraries/interfaces/Yii";
import { ISortOutput, SortDirection } from "libraries/interfaces/ISort";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { forkJoin, Observable } from "rxjs";
import { IaqoboAirPermission } from "app_locobook/shared/iaqobo-air-permission.enum";
import { EQuoteSorterActions } from "app_locobook/pages/quote-page/components/quote-list-container/quote-sorter/quote-sorter.service";
import { IRatingConfiguration } from "libraries/component/rating-table/rating-table.component";
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { defaultRatingConfiguration } from "libraries/component/rating-table/default-rating-configuration";
import { LocalizedPipe } from "libraries/pipes/localized/localized.pipe";

@Component({
    selector: 'quote-sorter',
    template: `
        <sorter [selectedActionName]="selectedActionName"
                [sortDirection]="sortDirection"
                [sortStorageKey]="sortStorageKey"
                [storageCategory]="storageCategory"
                [menuConfig]="menuConfig"
                [showIcons]="true"
                [showWording]="false"
                (onSort)="sort($event)"></sorter>
    `,
    styles: [`
        sorter ::ng-deep popup-menu ::ng-deep button {
            font-size: 1rem;
        }
    `]
})

export class QuoteSorterComponent implements OnInit {
    @Input()
    public sortStorageKey: string;

    @Input()
    public selectedActionName: string;

    @Input()
    public sortDirection: SortDirection;

    @Output()
    public readonly onSort: EventEmitter<ISortOutput> = new EventEmitter<ISortOutput>();

    public storageCategory: string = 'quoteSort';

    public menuConfig: IPopupMenuConfig = {
        buttonLabel: Yii.t('wui-shared-js', 'Trier les résultats'),
        items: [
            {
                label: Yii.t('wui-shared-js', 'Prix'),
                actionName: EQuoteSorterActions.price,
            },
            {
                label: Yii.t('wui-shared-js', 'Durée'),
                actionName: EQuoteSorterActions.duration,
            },
        ],
    };

    private readonly ratingItem: IMenuItem = {
        label: Yii.t('wui-shared-js', 'Note'),
        actionName: EQuoteSorterActions.rating,
    };
    private readonly carbonFootprintItem: IMenuItem = {
        label: 'CO\u2082',
        actionName: EQuoteSorterActions.carbonFootprint,
    };

    constructor(
        private readonly permissionResourceService: PermissionResourceService,
        private readonly configurationResourceService: ConfigurationResourceService,
        private readonly localizedPipe: LocalizedPipe,
    ) {
    }

    public ngOnInit(): void {
        const carbonFootprintPermission: Observable<boolean> =
            this.permissionResourceService.hasPermission(IaqoboAirPermission.SHARED_AIR_CARBON_FOOTPRINT_SHOW);
        const youcangooRatingPermission: Observable<boolean> =
            this.permissionResourceService.hasPermission(IaqoboAirPermission.IQBA_QUOTE_RATING_YUCANGOO_VIEW);

        forkJoin([
            carbonFootprintPermission,
            youcangooRatingPermission,
            this.configurationResourceService.get(["wui", "shared_air", "config", "rating", "rating.json"], defaultRatingConfiguration)
        ])
            .subscribe({
                next: ([carbonFootprint, youcangooRating, ratingConfig]: [boolean, boolean, IRatingConfiguration]): void => {
                    if (carbonFootprint) {
                        this.menuConfig.items.push(this.carbonFootprintItem);
                    }
                    if (youcangooRating) {
                        if(ratingConfig && ratingConfig.wording){
                            this.ratingItem.label = this.localizedPipe.transform(ratingConfig.wording);
                        }
                        this.menuConfig.items.push(this.ratingItem);

                    }
                },
            });
    }

    public sort(sortOutput: ISortOutput): void {
        this.onSort.emit(sortOutput);
    }


}
